import {
  IntegrationConnection,
  IntegrationType,
} from '@aibees/elephant/types/integration';
import {
  PaginationRequest,
  PaginationResponse,
} from '@aibees/shared/definition';
import { QueryOptions } from '@aibees/shared/http';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { INTEGRATION_API_PREFIX } from './constants';

type BrowseIntegrationRequest = PaginationRequest<{
  name?: string;
  type?: IntegrationType;
}>;
export function useBrowseIntegrationApi(
  params: BrowseIntegrationRequest,
  options?: QueryOptions
) {
  const workspace = useWorkspace();
  const { page, type, name, ...other } = params;

  return useBaseQuery<typeof params, PaginationResponse<IntegrationConnection>>(
    [useBrowseIntegrationApi.name, page, type, name, other],
    {
      url: INTEGRATION_API_PREFIX.replace(':wid', String(workspace?.id)),
      params,
    },
    options
  );
}
